export default "__VITE_ASSET__BKTJLkH4__"